import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzs6xTSSY3T27UnglpqY1oZOkV8YyvekVaTk7_ffTr_RztAj5cxKxRaknPk980cQv_4PA/exec';

const T = {
  "nav-about": { pt: "Sobre", en: "About" },
  "nav-svc": { pt: "Serviços", en: "Services" },
  "nav-diff": { pt: "Diferenciais", en: "Differentials" },
  "nav-sec": { pt: "Setores", en: "Sectors" },
  "nav-cta": { pt: "Fale Conosco", en: "Contact Us" },
  "hero-ey": { pt: "Apresentação Institucional 2026", en: "Institutional Overview 2026" },
  "hero-h1-pre": { pt: "Assuntos Regulatórios com ", en: "Regulatory Affairs with " },
  "hero-h1-em": { pt: "precisão", en: "precision" },
  "hero-h1-post": { pt: " e visão de negócio.", en: " and business vision." },
  "hero-sub": { pt: "Soluções especializadas para empresas que precisam de segurança jurídica, agilidade regulatória e conformidade em cada etapa do ciclo de vida dos seus produtos.", en: "Specialized solutions for companies that need legal certainty, regulatory agility and compliance at every stage of their product lifecycle." },
  "hero-cta1": { pt: "Solicitar Proposta", en: "Request a Proposal" },
  "hero-cta2": { pt: "Nossos Serviços", en: "Our Services" },
  "hs1": { pt: "Anos de Experiência", en: "Years of Experience" },
  "hs2": { pt: "Projetos Entregues", en: "Projects Delivered" },
  "hs3": { pt: "Taxa de Aprovação", en: "Approval Rate" },
  "hs4": { pt: "Alunos Capacitados", en: "Professionals Trained" },
  "about-ey": { pt: "Quem Somos", en: "About Us" },
  "about-title": { pt: "Autoridade técnica e expertise regulatória.", en: "Technical authority and regulatory expertise." },
  "about-desc": { pt: "A CGRA Consulting atua como assessoria estratégica e braço operacional, oferecendo soluções completas para a regularização, registro e comercialização do seu produto no Brasil e nos principais mercados globais.", en: "CGRA Consulting acts as a strategic advisory and operational arm, delivering end-to-end solutions for product registration, regularization and market access in Brazil and key global markets." },
  "about-extra": { pt: "Combinamos mais de 15 anos de atuação no mercado regulatório com tecnologia proprietária e metodologia exclusiva. Cada projeto é conduzido com profundidade técnica, foco em resultado e total segurança jurídica.", en: "We combine over 15 years of regulatory market experience with proprietary technology and an exclusive methodology. Every project is conducted with technical depth, results-driven focus and full legal certainty." },
  "ap1h": { pt: "Atuação Estratégica", en: "Strategic Approach" },
  "ap1p": { pt: "Relacionamento técnico e profundo conhecimento das normas dos principais órgãos reguladores do país.", en: "Deep technical relationships and thorough knowledge of regulations across Brazil's key regulatory bodies." },
  "ap2h": { pt: "Metodologia e Tecnologia Próprias", en: "Proprietary Methodology & Technology" },
  "ap2p": { pt: "Abordagem exclusiva focada na aplicabilidade prática das normas dentro do contexto de cada negócio.", en: "An exclusive approach focused on the practical applicability of regulations within each business context." },
  "ap3h": { pt: "Histórico de Alta Performance", en: "High-Performance Track Record" },
  "ap3p": { pt: "Taxa de 90% de aprovação em processos complexos, reduzindo retrabalho e acelerando o time-to-market.", en: "90% approval rate on complex submissions, reducing rework and accelerating time-to-market." },
  "svc-ey": { pt: "Nossos Serviços", en: "Our Services" },
  "svc-title": { pt: "Como atuamos para apoiar seu negócio.", en: "How we support your business." },
  "svc-desc": { pt: "Do diagnóstico regulatório à aprovação final, cobrimos cada etapa com precisão técnica e visão de negócio.", en: "From regulatory assessment to final approval, we cover every step with technical precision and business vision." },
  "s1h": { pt: "Consultoria e Assessoria Regulatória", en: "Regulatory Consulting & Advisory" },
  "s1p": { pt: "Diagnóstico de riscos, mapeamento de cenários e desenvolvimento de estratégias regulatórias personalizadas para o seu modelo de negócio.", en: "Risk assessment, scenario mapping and development of tailored regulatory strategies for your business model." },
  "s2h": { pt: "Registro de Produtos", en: "Product Registration" },
  "s2p": { pt: "Regularização completa (Notificação, Cadastro ou Registro) na ANVISA, MAPA, INMETRO e ANATEL, incluindo análise de rotulagem.", en: "Full regularization (Notification, Registration or Listing) with ANVISA, MAPA, INMETRO and ANATEL, including labeling analysis." },
  "s3h": { pt: "Regularização de Empresas", en: "Company Regularization" },
  "s3p": { pt: "Obtenção de licenças e autorizações junto à VISA local, Prefeitura, Corpo de Bombeiros e demais órgãos para operação legal.", en: "Obtaining licenses and authorizations from local health authorities, city hall, fire department and other agencies for lawful operation." },
  "s4h": { pt: "Dossiês Técnicos e Submissões", en: "Technical Dossiers & Submissions" },
  "s4p": { pt: "Estruturação completa, validação e protocolo final de dossiês técnicos conforme requisitos dos órgãos reguladores.", en: "End-to-end structuring, validation and final protocol of technical dossiers per regulatory body requirements." },
  "s5h": { pt: "Mentoria e Capacitação", en: "Mentoring & Training" },
  "s5p": { pt: "Treinamentos in-company e mentoria para times técnicos, focados na interpretação e aplicação prática das normas sanitárias.", en: "In-company training and mentoring for technical teams, focused on practical interpretation and application of health regulations." },
  "s6h": { pt: "Monitoramento Regulatório", en: "Regulatory Monitoring" },
  "s6p": { pt: "Acompanhamento contínuo de publicações no D.O.U. e atualizações normativas, garantindo antecipação de mudanças no cenário.", en: "Continuous monitoring of Official Gazette publications and regulatory updates, ensuring proactive response to changes." },
  "met-ey": { pt: "Metodologia Proprietária", en: "Proprietary Methodology" },
  "met-desc": { pt: "Nossa metodologia exclusiva estrutura cada projeto em três fases integradas, reduzindo riscos e acelerando resultados.", en: "Our exclusive methodology structures every project in three integrated phases, reducing risk and accelerating results." },
  "m1h": { pt: "Fase 1: Diagnóstico", en: "Phase 1: Assessment" },
  "m1p": { pt: "Diagnóstico regulatório completo e alinhamento estratégico inicial. Mapeamos requisitos, identificamos gaps e definimos o escopo do projeto.", en: "Full regulatory assessment and initial strategic alignment. We map requirements, identify gaps and define the project scope." },
  "m2h": { pt: "Fase 2: Desenvolvimento", en: "Phase 2: Development" },
  "m2p": { pt: "Desenvolvimento técnico, organização documental e validação completa. Construímos o dossiê com precisão e conformidade total.", en: "Technical development, document organization and full validation. We build the dossier with precision and total compliance." },
  "m3h": { pt: "Fase 3: Submissão", en: "Phase 3: Submission" },
  "m3p": { pt: "Submissão ao órgão regulador, acompanhamento das interações e evolução contínua do projeto até a aprovação final.", en: "Submission to the regulatory body, follow-up on interactions and continuous project evolution until final approval." },
  "diff-ey": { pt: "Diferenciais", en: "Differentials" },
  "diff-title": { pt: "Por que escolher a CGRA.", en: "Why choose CGRA." },
  "diff-desc": { pt: "Reunimos os elementos que garantem segurança, agilidade e resultado em cada projeto regulatório.", en: "We bring together the elements that ensure safety, agility and results in every regulatory project." },
  "d1h": { pt: "Especialização Sênior", en: "Senior Expertise" },
  "d1p": { pt: "Atuação profunda nos principais órgãos reguladores do país, com equipe técnica altamente qualificada.", en: "Deep engagement with Brazil's key regulatory bodies, backed by a highly qualified technical team." },
  "d2h": { pt: "Tecnologia Própria", en: "Proprietary Technology" },
  "d2p": { pt: "Ferramentas proprietárias que organizam, validam e acompanham cada etapa do processo regulatório com rastreabilidade total.", en: "Proprietary tools that organize, validate and track every step of the regulatory process with full traceability." },
  "d3h": { pt: "Metodologia Exclusiva", en: "Exclusive Methodology" },
  "d3p": { pt: "ARE Method™ para estruturar projetos com previsibilidade, reduzir riscos e acelerar aprovações.", en: "ARE Method™ to structure projects with predictability, reduce risks and accelerate approvals." },
  "d4h": { pt: "Qualidade Técnica Consistente", en: "Consistent Technical Quality" },
  "d4p": { pt: "Dossiês padronizados, completos e prontos para submissão, com total segurança regulatória.", en: "Standardized, complete dossiers ready for submission, with full regulatory certainty." },
  "d5h": { pt: "Visão Estratégica de Negócio", en: "Strategic Business Vision" },
  "d5p": { pt: "Regulatório conectado a planejamento, gestão de risco e oportunidade comercial para o seu produto.", en: "Regulatory connected to planning, risk management and commercial opportunity for your product." },
  "d6h": { pt: "Alta Performance", en: "High Performance" },
  "d6p": { pt: "90% de taxa de aprovação, precisão documental e condução eficiente do processo regulado.", en: "90% approval rate, document precision and efficient management of the regulated process." },
  "sec-ey": { pt: "Setores de Atuação", en: "Sectors We Serve" },
  "sec-title": { pt: "Mercados que atendemos.", en: "Markets we serve." },
  "sec-desc": { pt: "Atuamos como ponte estratégica para empresas que desejam internacionalizar seus produtos ou operar no mercado brasileiro com total conformidade.", en: "We act as a strategic bridge for companies looking to internationalize their products or operate in Brazil with full compliance." },
  "sc1h": { pt: "Saúde e Dispositivos Médicos", en: "Healthcare & Medical Devices" },
  "sc1p": { pt: "Equipamentos, materiais para saúde, implantes e diagnósticos in vitro.", en: "Equipment, health materials, implants and in-vitro diagnostics." },
  "sc2h": { pt: "Cosméticos e Saneantes", en: "Cosmetics & Sanitizers" },
  "sc2p": { pt: "Produtos de higiene pessoal, perfumaria, cosméticos e produtos de limpeza.", en: "Personal care, fragrance, cosmetics and cleaning products." },
  "sc3h": { pt: "Alimentos e Suplementos", en: "Food & Supplements" },
  "sc3p": { pt: "Alimentos especiais, suplementos alimentares, fórmulas e bebidas reguladas.", en: "Specialty foods, dietary supplements, formulas and regulated beverages." },
  "sc4h": { pt: "Veterinário", en: "Veterinary" },
  "sc4p": { pt: "Produtos e medicamentos de uso veterinário com conformidade MAPA.", en: "Veterinary products and medicines with MAPA compliance." },
  "cli-ey": { pt: "Portfólio de Sucesso", en: "Success Portfolio" },
  "cli-title": { pt: "Clientes que confiam na CGRA.", en: "Clients who trust CGRA." },
  "cli-desc": { pt: "Construímos relações de confiança e parcerias duradouras com empresas líderes em diversos segmentos, entregando soluções regulatórias que viabilizam negócios.", en: "We build trust-based relationships and lasting partnerships with leading companies across segments, delivering regulatory solutions that enable business." },
  "ct-ey": { pt: "Vamos Conversar", en: "Let's Talk" },
  "ct-title": { pt: "Entre em contato.", en: "Get in touch." },
  "ct-desc": { pt: "Preencha seus dados e um dos nossos especialistas entra em contato para entender seu cenário e propor os próximos passos.", en: "Fill in your details and one of our specialists will reach out to understand your situation and propose next steps." },
  "fm-h3": { pt: "Solicitar Proposta", en: "Request a Proposal" },
  "fm-sub": { pt: "Responderemos em até 24 horas úteis.", en: "We'll respond within 24 business hours." },
  "fl1": { pt: "Nome completo", en: "Full name" },
  "fl2": { pt: "E-mail corporativo", en: "Corporate e-mail" },
  "fl3": { pt: "Telefone / WhatsApp", en: "Phone / WhatsApp" },
  "fl4": { pt: "Empresa", en: "Company" },
  "fl5": { pt: "Área de interesse", en: "Area of interest" },
  "fl6": { pt: "Mensagem (opcional)", en: "Message (optional)" },
  "fo0": { pt: "Selecione...", en: "Select..." },
  "fo1": { pt: "Registro de Produto (ANVISA)", en: "Product Registration (ANVISA)" },
  "fo2": { pt: "Registro de Produto (MAPA)", en: "Product Registration (MAPA)" },
  "fo3": { pt: "Registro de Produto (INMETRO)", en: "Product Registration (INMETRO)" },
  "fo4": { pt: "Regularização de Empresa", en: "Company Regularization" },
  "fo5": { pt: "Dossiê Técnico", en: "Technical Dossier" },
  "fo6": { pt: "Consultoria Estratégica", en: "Strategic Consulting" },
  "fo7": { pt: "Due Diligence Regulatória", en: "Regulatory Due Diligence" },
  "fo8": { pt: "Treinamento / Mentoria", en: "Training / Mentoring" },
  "fo9": { pt: "Monitoramento Regulatório", en: "Regulatory Monitoring" },
  "fo10": { pt: "Outro", en: "Other" },
  "fm-btn": { pt: "Enviar Solicitação", en: "Submit Request" },
  "ph-name": { pt: "Seu nome", en: "Your name" },
  "ph-email": { pt: "email@empresa.com", en: "email@company.com" },
  "ph-company": { pt: "Nome da empresa", en: "Company name" },
  "ph-msg": { pt: "Descreva brevemente seu cenário ou necessidade...", en: "Briefly describe your scenario or needs..." },
  "msg-ok": { pt: "Solicitação enviada com sucesso. Entraremos em contato em breve.", en: "Request submitted successfully. We will be in touch shortly." },
  "msg-err-required": { pt: "Por favor, preencha nome e e-mail.", en: "Please fill in name and e-mail." },
  "msg-err-send": { pt: "Erro ao enviar. Tente novamente.", en: "Error sending. Please try again." },
  "msg-sending": { pt: "Enviando...", en: "Sending..." },
};

function App() {
  const [lang, setLang] = useState('pt');
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [formMsg, setFormMsg] = useState({ text: '', type: '' });
  const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', area: '', message: '' });

  const t = useCallback((key) => T[key]?.[lang] || '', [lang]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('vis');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollTo = (e, selector) => {
    e.preventDefault();
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMobileOpen(false);
  };

  const changeLang = (l) => {
    setLang(l);
    document.documentElement.lang = l === 'pt' ? 'pt-BR' : 'en';
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const submitLead = async () => {
    if (!form.name || !form.email) {
      setFormMsg({ text: t('msg-err-required'), type: 'err' });
      return;
    }
    setFormMsg({ text: t('msg-sending'), type: '' });
    const payload = { name: form.name, email: form.email, phone: form.phone, company: form.company, area: form.area, msg: form.message, lang, date: new Date().toISOString() };
    try {
      fetch(SCRIPT_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, lang, date: new Date().toISOString() }),
      });
      setFormMsg({ text: t('msg-ok'), type: 'ok' });
      setForm({ name: '', email: '', phone: '', company: '', area: '', message: '' });
    } catch {
      setFormMsg({ text: t('msg-err-send'), type: 'err' });
    }
  };

  return (
    <>
      {/* NAV */}
      <nav className={`nav${scrolled ? ' scrolled' : ''}`} data-testid="main-nav">
        <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="nav-logo" data-testid="nav-logo">
          <b>CGRA</b><span>CONSULTING</span>
        </a>
        <div className={`nav-links${mobileOpen ? ' mob-open' : ''}`}>
          <a href="#sobre" onClick={(e) => scrollTo(e, '#sobre')} data-testid="nav-about">{t('nav-about')}</a>
          <a href="#servicos" onClick={(e) => scrollTo(e, '#servicos')} data-testid="nav-services">{t('nav-svc')}</a>
          <a href="#diferenciais" onClick={(e) => scrollTo(e, '#diferenciais')} data-testid="nav-diff">{t('nav-diff')}</a>
          <a href="#setores" onClick={(e) => scrollTo(e, '#setores')} data-testid="nav-sectors">{t('nav-sec')}</a>
          <div className="lang-toggle" data-testid="lang-toggle">
            <button className={`lang-btn${lang === 'pt' ? ' active' : ''}`} onClick={() => changeLang('pt')} data-testid="lang-pt">PT</button>
            <button className={`lang-btn${lang === 'en' ? ' active' : ''}`} onClick={() => changeLang('en')} data-testid="lang-en">EN</button>
          </div>
          <a href="#contato" onClick={(e) => scrollTo(e, '#contato')} className="nav-cta" data-testid="nav-cta">{t('nav-cta')}</a>
        </div>
        <button className="mob-btn" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu" data-testid="mobile-menu-btn">
          <i></i><i></i><i></i>
        </button>
      </nav>

      {/* HERO */}
      <section className="hero" id="hero" data-testid="hero-section">
        <div className="hero-grid">
          <div>
            <div className="hero-ey">{t('hero-ey')}</div>
            <h1>{t('hero-h1-pre')}<em>{t('hero-h1-em')}</em>{t('hero-h1-post')}</h1>
            <p className="hero-sub">{t('hero-sub')}</p>
            <div className="hero-organs">
              <div className="hero-organ">ANVISA</div>
              <div className="hero-organ">MAPA</div>
              <div className="hero-organ">INMETRO</div>
              <div className="hero-organ">VISA LOCAL</div>
            </div>
            <div className="hero-actions">
              <a href="#contato" onClick={(e) => scrollTo(e, '#contato')} className="btn-p" data-testid="hero-cta-proposal">{t('hero-cta1')}</a>
              <a href="#servicos" onClick={(e) => scrollTo(e, '#servicos')} className="btn-s" data-testid="hero-cta-services">{t('hero-cta2')}</a>
            </div>
          </div>
          <div className="hero-stats" data-testid="hero-stats">
            <div className="hero-stat"><div className="hero-stat-val">15+</div><div className="hero-stat-lbl">{t('hs1')}</div></div>
            <div className="hero-stat"><div className="hero-stat-val">300+</div><div className="hero-stat-lbl">{t('hs2')}</div></div>
            <div className="hero-stat"><div className="hero-stat-val">90%</div><div className="hero-stat-lbl">{t('hs3')}</div></div>
            <div className="hero-stat"><div className="hero-stat-val">3.5K+</div><div className="hero-stat-lbl">{t('hs4')}</div></div>
          </div>
        </div>
      </section>

      <div className="gold-line"></div>

      {/* ABOUT */}
      <section className="s-light" id="sobre" data-testid="about-section">
        <div className="s-inner fade-up">
          <div className="about-grid">
            <div>
              <div className="s-ey">{t('about-ey')}</div>
              <div className="s-title">{t('about-title')}</div>
              <p className="s-desc">{t('about-desc')}</p>
              <p style={{ fontSize: '14px', lineHeight: 1.7, color: 'var(--text2)', maxWidth: '520px' }}>{t('about-extra')}</p>
            </div>
            <div className="about-right">
              <div className="about-pill">
                <div className="about-pill-icon"><svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg></div>
                <div><h4>{t('ap1h')}</h4><p>{t('ap1p')}</p></div>
              </div>
              <div className="about-pill">
                <div className="about-pill-icon"><svg viewBox="0 0 24 24"><path d="M12 20V10M18 20V4M6 20v-4" /></svg></div>
                <div><h4>{t('ap2h')}</h4><p>{t('ap2p')}</p></div>
              </div>
              <div className="about-pill">
                <div className="about-pill-icon"><svg viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><path d="M22 4L12 14.01l-3-3" /></svg></div>
                <div><h4>{t('ap3h')}</h4><p>{t('ap3p')}</p></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="s-light" id="servicos" style={{ paddingTop: 0 }} data-testid="services-section">
        <div className="s-inner fade-up">
          <div className="s-ey">{t('svc-ey')}</div>
          <div className="s-title">{t('svc-title')}</div>
          <p className="s-desc">{t('svc-desc')}</p>
          <div className="svc-grid" data-testid="services-grid">
            <div className="svc-card"><div className="svc-num">01</div><h3>{t('s1h')}</h3><p>{t('s1p')}</p></div>
            <div className="svc-card"><div className="svc-num">02</div><h3>{t('s2h')}</h3><p>{t('s2p')}</p></div>
            <div className="svc-card"><div className="svc-num">03</div><h3>{t('s3h')}</h3><p>{t('s3p')}</p></div>
            <div className="svc-card"><div className="svc-num">04</div><h3>{t('s4h')}</h3><p>{t('s4p')}</p></div>
            <div className="svc-card"><div className="svc-num">05</div><h3>{t('s5h')}</h3><p>{t('s5p')}</p></div>
            <div className="svc-card"><div className="svc-num">06</div><h3>{t('s6h')}</h3><p>{t('s6p')}</p></div>
          </div>
        </div>
      </section>

      {/* METHODOLOGY */}
      <section className="s-light" style={{ paddingTop: 0 }} id="metodologia" data-testid="methodology-section">
        <div className="s-inner fade-up">
          <div className="s-ey">{t('met-ey')}</div>
          <div className="s-title">ARE Method&trade;</div>
          <p className="s-desc">{t('met-desc')}</p>
          <div className="method-row">
            <div className="method-step"><div className="method-ltr">A</div><h3>Assess &amp; Align</h3><h4>{t('m1h')}</h4><p>{t('m1p')}</p></div>
            <div className="method-step"><div className="method-ltr">R</div><h3>Regulate &amp; Review</h3><h4>{t('m2h')}</h4><p>{t('m2p')}</p></div>
            <div className="method-step"><div className="method-ltr">E</div><h3>Execute &amp; Evolve</h3><h4>{t('m3h')}</h4><p>{t('m3p')}</p></div>
          </div>
        </div>
      </section>

      {/* DIFFERENTIALS */}
      <section className="s-dark" id="diferenciais" data-testid="differentials-section">
        <div className="s-inner fade-up">
          <div className="s-ey">{t('diff-ey')}</div>
          <div className="s-title">{t('diff-title')}</div>
          <p className="s-desc">{t('diff-desc')}</p>
          <div className="diff-grid">
            <div className="diff-card"><h3>{t('d1h')}</h3><p>{t('d1p')}</p></div>
            <div className="diff-card"><h3>{t('d2h')}</h3><p>{t('d2p')}</p></div>
            <div className="diff-card"><h3>{t('d3h')}</h3><p>{t('d3p')}</p></div>
            <div className="diff-card"><h3>{t('d4h')}</h3><p>{t('d4p')}</p></div>
            <div className="diff-card"><h3>{t('d5h')}</h3><p>{t('d5p')}</p></div>
            <div className="diff-card"><h3>{t('d6h')}</h3><p>{t('d6p')}</p></div>
          </div>
        </div>
      </section>

      {/* SECTORS */}
      <section className="s-dark2" id="setores" data-testid="sectors-section">
        <div className="s-inner fade-up">
          <div className="s-ey">{t('sec-ey')}</div>
          <div className="s-title">{t('sec-title')}</div>
          <p className="s-desc">{t('sec-desc')}</p>
          <div className="sectors-grid">
            <div className="sector-card">
              <div className="sector-icon"><svg viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg></div>
              <h3>{t('sc1h')}</h3><p>{t('sc1p')}</p>
            </div>
            <div className="sector-card">
              <div className="sector-icon"><svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 100 20 10 10 0 000-20z" /><path d="M8 14s1.5 2 4 2 4-2 4-2" /><line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" /></svg></div>
              <h3>{t('sc2h')}</h3><p>{t('sc2p')}</p>
            </div>
            <div className="sector-card">
              <div className="sector-icon"><svg viewBox="0 0 24 24"><path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" /><line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="14" y1="1" x2="14" y2="4" /></svg></div>
              <h3>{t('sc3h')}</h3><p>{t('sc3p')}</p>
            </div>
            <div className="sector-card">
              <div className="sector-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" /></svg></div>
              <h3>{t('sc4h')}</h3><p>{t('sc4p')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CLIENTS */}
      <section className="s-light" id="clientes" data-testid="clients-section">
        <div className="s-inner fade-up" style={{ textAlign: 'center' }}>
          <div className="s-ey" style={{ justifyContent: 'center' }}>{t('cli-ey')}</div>
          <div className="s-title" style={{ maxWidth: 'none' }}>{t('cli-title')}</div>
          <p className="s-desc" style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>{t('cli-desc')}</p>
          <div className="clients-logos" data-testid="clients-logos">
            <div className="cl-logo"><svg viewBox="0 0 180 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'Playfair Display',Georgia,serif" fontSize="22" fontWeight="600" fill="#1a1a18" letterSpacing="3">BIODERMA</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 180 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'DM Sans',Helvetica,sans-serif" fontSize="20" fontWeight="700" fill="#1a1a18" letterSpacing="4">HEINEKEN</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 140 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'Playfair Display',Georgia,serif" fontSize="22" fontWeight="500" fill="#1a1a18" letterSpacing="2">ANVISA</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 160 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'Playfair Display',Georgia,serif" fontSize="21" fontWeight="500" fill="#1a1a18" letterSpacing="3">CAUDALIE</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 140 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'DM Sans',Helvetica,sans-serif" fontSize="22" fontWeight="300" fill="#1a1a18" letterSpacing="5">FILORGA</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 70 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'DM Sans',Helvetica,sans-serif" fontSize="24" fontWeight="700" fill="#1a1a18" letterSpacing="3">BVI</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 160 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'DM Sans',Helvetica,sans-serif" fontSize="20" fontWeight="500" fill="#1a1a18" letterSpacing="4">OPTIKON</text></svg></div>
            <div className="cl-logo"><svg viewBox="0 0 190 32" xmlns="http://www.w3.org/2000/svg"><text x="0" y="24" fontFamily="'DM Sans',Helvetica,sans-serif" fontSize="19" fontWeight="600" fill="#1a1a18" letterSpacing="3">APPASAMY</text></svg></div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="s-dark" id="contato" data-testid="contact-section">
        <div className="s-inner fade-up">
          <div className="form-grid">
            <div className="form-left">
              <div className="s-ey">{t('ct-ey')}</div>
              <div className="s-title">{t('ct-title')}</div>
              <p className="s-desc">{t('ct-desc')}</p>
              <div className="form-contact-item">
                <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                contato@cgraconsulting.com
              </div>
              <div className="form-contact-item">
                <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>
                +55 11 97872-1720
              </div>
              <div className="form-contact-item">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" /></svg>
                cgraconsulting.com
              </div>
            </div>
            <div className="form-box" data-testid="contact-form">
              <h3>{t('fm-h3')}</h3>
              <p className="form-sub">{t('fm-sub')}</p>
              <div className="form-field">
                <label>{t('fl1')}</label>
                <input type="text" name="name" value={form.name} onChange={handleChange} placeholder={t('ph-name')} data-testid="form-name" />
              </div>
              <div className="form-field">
                <label>{t('fl2')}</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder={t('ph-email')} data-testid="form-email" />
              </div>
              <div className="form-field">
                <label>{t('fl3')}</label>
                <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="+55 (11) 99999-9999" data-testid="form-phone" />
              </div>
              <div className="form-field">
                <label>{t('fl4')}</label>
                <input type="text" name="company" value={form.company} onChange={handleChange} placeholder={t('ph-company')} data-testid="form-company" />
              </div>
              <div className="form-field">
                <label>{t('fl5')}</label>
                <select name="area" value={form.area} onChange={handleChange} data-testid="form-area">
                  <option value="">{t('fo0')}</option>
                  <option value="Registro de Produto (ANVISA)">{t('fo1')}</option>
                  <option value="Registro de Produto (MAPA)">{t('fo2')}</option>
                  <option value="Registro de Produto (INMETRO)">{t('fo3')}</option>
                  <option value="Regularização de Empresa">{t('fo4')}</option>
                  <option value="Dossiê Técnico">{t('fo5')}</option>
                  <option value="Consultoria Estratégica">{t('fo6')}</option>
                  <option value="Due Diligence Regulatória">{t('fo7')}</option>
                  <option value="Treinamento / Mentoria">{t('fo8')}</option>
                  <option value="Monitoramento Regulatório">{t('fo9')}</option>
                  <option value="Outro">{t('fo10')}</option>
                </select>
              </div>
              <div className="form-field">
                <label>{t('fl6')}</label>
                <textarea name="message" value={form.message} onChange={handleChange} placeholder={t('ph-msg')} rows="3" data-testid="form-message" />
              </div>
              <button className="btn-p form-submit" onClick={submitLead} data-testid="form-submit-btn">{t('fm-btn')}</button>
              <div className={`form-msg ${formMsg.type}`} data-testid="form-msg">{formMsg.text}</div>
            </div>
          </div>
        </div>
      </section>

      <footer data-testid="footer">
        <div className="foot-inner">
          <div className="foot-logo"><b>CGRA</b><span>CONSULTING</span></div>
          <div className="foot-right">&copy; 2026 CGRA Consulting. Todos os direitos reservados.</div>
        </div>
      </footer>
    </>
  );
}

export default App;
